// extracted by mini-css-extract-plugin
export default {"heading":"_24oW","ibox":"_3kzL","pagination":"_2xZp"};